import(/* webpackMode: "eager" */ "/app/apps/data-dashboard/app/[locale]/error.tsx");
